import {
  OD_REVIEW_PHASES,
  OdReviewPhase,
} from "../../../services/odReview/odReview.types";

export const OD_REVIEW_PHASE_LABELS: Record<OdReviewPhase, string> = {
  text: "Texto",
  resources: "Recursos",
  photos: "Fotos",
};

export const DEFAULT_RUN_PHASES: OdReviewPhase[] = [...OD_REVIEW_PHASES];

export function normalizeRunPhases(
  selected: OdReviewPhase[] | undefined,
): OdReviewPhase[] {
  const chosen = selected ?? [];
  return OD_REVIEW_PHASES.filter(
    (phase) => phase === "text" || chosen.includes(phase),
  );
}
